import { FileEditUploader } from "@/entities";
import {
  Panel,
  PanelHeader,
  PanelBody,
  PanelLoader,
  PanelError,
} from "@/shared";

interface Props {
  panelTitle: string;
  error: any;
  isLoading: boolean;
  data: any;
}
export function UserCover({ panelTitle, error, isLoading, data }: Props) {
  if (error) {
    return <PanelError error={error} />;
  }

  if (isLoading) {
    return <PanelLoader panelTitle={panelTitle} />;
  }

  return (
    <Panel queryKey={`admin-user-${data.result.id}`}>
      <PanelHeader>{panelTitle}</PanelHeader>
      <PanelBody className="p-0">
        <FileEditUploader
          queryKey={`admin-users-${data.result.id}`}
          table="user"
          column="cover_src"
          id={data.result.id}
          timestamp={data.result.timestamp}
          file={data.result.cover_src}
          accept="image/*"
        />
      </PanelBody>
    </Panel>
  );
}
